import lang from "@/views/modules/Applications/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_NAME,
    },
    'status': {
        label: lang.LBL_STATUS,
    },
};
export default { searchFieldsDef }